import { FgStatusEnum, GlobalStatus, GradeInvStatusEnum, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("grade_inventory_log")
export class GradeInventoryLog {

    @PrimaryGeneratedColumn("increment", { name: 'grade_inv_log_id' })
    gradeInvLogId: number;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;
    @Column('int', {
        nullable: true,
        name: "sub_plant_id"
    })
    subPlantId: number;

    @Column({
        type: 'enum',
        enum: ShiftsEnum,
        nullable: false,
        name: 'shift'
    })
    shift: ShiftsEnum;

    @Column({
        type: 'enum',
        enum: WorkStationTypeEnum,
        nullable: true,
        name: 'workstation_type'
    })
    workStationType: WorkStationTypeEnum;

    @Column("int", {
        nullable: false,
        name: "workstation",
    })
    workstation: number;

    @Column("varchar", {
        nullable: false,
        name: "lot_number",
        length: 50
    })
    lotNumber: string;

    @Column("int", {
        nullable: false,
        name: "grade"
    })
    grade: number;

    @Column("int", {
        nullable: false,
        name: "boxes"
    })
    boxes: number;    

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "quantity"
    })
    quantity: number; 

    @Column({
        type: 'enum',
        enum: GradeInvStatusEnum,
        nullable: true,
        name: 'quantity_type'
    })
    quantityType: GradeInvStatusEnum;

    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;

    @Column("int", {
        nullable: true,
        name: "supervisor"
    })
    supervisor: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('boolean',{
        name:'material_from',
        default:false
    })
    materialFrom : boolean

    @Column('int',{
        name:'year'
    })
    year:number

    @Column('datetime',{
        name:'date',
        nullable:false
    })
    date:  Date
}